import { render, staticRenderFns } from "./clientGrouping.vue?vue&type=template&id=2f9ff64c&"
import script from "./clientGrouping.vue?vue&type=script&lang=js&"
export * from "./clientGrouping.vue?vue&type=script&lang=js&"
import style0 from "./clientGrouping.vue?vue&type=style&index=0&id=2f9ff64c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports